import { connect } from 'react-redux'
import Settings from 'modules/Settings/index'
import authSelector from 'modules/Auth/selectors'
import corporateSelector from 'modules/Roles/selectors'
import settingsSelector from 'modules/Settings/selectors'
import { getIndustries } from 'modules/Roles/actions'
import {
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  getUserRoles,
  updateCorporateDetails,
} from 'modules/Auth/actions'

import {
  getCorporateLocationsList,
  addCorporateBranch,
  getLocationDetails,
  updateLocationAPI,
  deleteLocationAPI,
} from 'modules/Settings/actions'

const mapStateToProps = state => ({
  corporateData: authSelector.getCorporateData(state),
  listOfCountries: authSelector.getListOfCountries(state),
  listOfStates: authSelector.getListOfStates(state),
  listOfCities: authSelector.getListOfCities(state),
  userRoles: authSelector?.getUserRoleList(state),

  industriesList: corporateSelector.getIndustriesList(state),

  corporateLocationsList: settingsSelector.getCorporateLocations(state),
  singleLocationData: settingsSelector.getSingleLocationData(state),
  permissions : authSelector.getUserPermissions(state)
})
const mapDispatchToProps = {
  getIndustries,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  getUserRoles,
  updateCorporateDetails,
  getCorporateLocationsList,
  addCorporateBranch,
  getLocationDetails,
  updateLocationAPI,
  deleteLocationAPI,
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
